import { icons } from "../../const/icons";
import { CustomConfirm } from "../Modals/CustomConfirm";
import PropTypes from "prop-types";

/**
 * Modal de confirmación para eliminar la asignación de un producto a un almacén.
 *
 * @param {boolean} visible - Controla la visibilidad del modal
 * @param {object} product - Producto seleccionado para desasignar
 * @param {object} almacen - Nombre del almacén actual
 * @param {function} onConfirm - Acción al confirmar la eliminación
 * @param {function} onCancel - Acción al cancelar
 * @param {boolean} saving - Controla estado del fetch
 */
export const InventarioConfirmUnassignStore = ({
  visible,
  product,
  almacen,
  onConfirm,
  onCancel,
  saving = false,
}) => {
  if (!product) return null;

  const description = (
    <>
      El producto <strong>&quot;{product.product}&quot;</strong> será eliminado del almacén{" "}
      <strong>&quot;{almacen.name}&quot;</strong>.
      <br />
      <span className="text-muted">
        Seguirá disponible en otros almacenes si está asignado a ellos. Puede reasignarlo
        posteriormente si lo desea.
      </span>
    </>
  );

  return (
    <CustomConfirm
      visible={visible}
      caption="Atención"
      description={null}
      iconUrl={icons.atencion}
      okText="Aceptar"
      showCancel={false}
      confirmLoading={saving}
      onConfirm={onConfirm}
      onCancel={onCancel}
      width={480}
    >
      {description}
    </CustomConfirm>
  );
};

InventarioConfirmUnassignStore.propTypes = {
  visible: PropTypes.bool,
  product: PropTypes.object,
  almacen: PropTypes.object,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  saving: PropTypes.bool,
};
